import React, { useMemo, useState } from 'react'
import UiComponentSidebar from './components/UiComponentSidebar'
import ActionButtonsShowcase from './showcases/ActionButtonsShowcase'
import AlertShowcase from './showcases/AlertShowcase'
import AccordionShowcase from './showcases/AccordionShowcase'
import AreaChartShowcase from './showcases/AreaChartShowcase'
import AutocompleteShowcase from './showcases/AutocompleteShowcase'
import BreadcrumbsShowcase from './showcases/BreadcrumbsShowcase'
import AvatarShowcase from './showcases/AvatarShowcase'
import AudioPlayerShowcase from './showcases/AudioPlayerShowcase'
import BadgeShowcase from './showcases/BadgeShowcase'
import BarChartShowcase from './showcases/BarChartShowcase'
import ButtonShowcase from './showcases/ButtonShowcase'
import CalendarShowcase from './showcases/CalendarShowcase'
import ChartingTabsShowcase from './showcases/ChartingTabsShowcase'
import CheckboxShowcase from './showcases/CheckboxShowcase'
import ColorSelectShowcase from './showcases/ColorSelectShowcase'
import ComboboxShowcase from './showcases/ComboboxShowcase'
import DonutChartShowcase from './showcases/DonutChartShowcase'
import EmptyStateShowcase from './showcases/EmptyStateShowcase'
import FileActionsShowcase from './showcases/FileActionsShowcase'
import InputWithUnitShowcase from './showcases/InputWithUnitShowcase'
import LinkButtonShowcase from './showcases/LinkButtonShowcase'
import LineChartShowcase from './showcases/LineChartShowcase'
import RadioShowcase from './showcases/RadioShowcase'
import ColorPaletteShowcase from './showcases/ColorPaletteShowcase'
import TypographyShowcase from './showcases/TypographyShowcase'
import IconsShowcase from './showcases/IconsShowcase'
import ContextualMenuShowcase from './showcases/ContextualMenuShowcase'
import DataTableShowcase from './showcases/DataTableShowcase'
import DayTimeSelectorShowcase from './showcases/DayTimeSelectorShowcase'
import DescriptionListShowcase from './showcases/DescriptionListShowcase'
import DetailCardShowcase from './showcases/DetailCardShowcase'
import DrawerShowcase from './showcases/DrawerShowcase'
import HeaderShowcase from './showcases/HeaderShowcase'
import InputFieldShowcase from './showcases/InputFieldShowcase'
import ModalShowcase from './showcases/ModalShowcase'
import MetricCardShowcase from './showcases/MetricCardShowcase'
import MailboxNavShowcase from './showcases/MailboxNavShowcase'
import MultiselectComboboxShowcase from './showcases/MultiselectComboboxShowcase'
import NavListShowcase from './showcases/NavListShowcase'
import OverlayShowcase from './showcases/OverlayShowcase'
import PaginationShowcase from './showcases/PaginationShowcase'
import PieChartShowcase from './showcases/PieChartShowcase'
import ProgressBarShowcase from './showcases/ProgressBarShowcase'
import RichTextEditorShowcase from './showcases/RichTextEditorShowcase'
import SearchShowcase from './showcases/SearchShowcase'
import ScreenLoaderShowcase from './showcases/ScreenLoaderShowcase'
import ScheduleCardShowcase from './showcases/ScheduleCardShowcase'
import SchedulerShowcase from './showcases/SchedulerShowcase'
import SectionCardShowcase from './showcases/SectionCardShowcase'
import SelectableCardShowcase from './showcases/SelectableCardShowcase'
import SelectableListShowcase from './showcases/SelectableListShowcase'
import SelectShowcase from './showcases/SelectShowcase'
import SelectChipShowcase from './showcases/SelectChipShowcase'
import SelectionBoxShowcase from './showcases/SelectionBoxShowcase'
import SmoothAreaChartShowcase from './showcases/SmoothAreaChartShowcase'
import SortFilterShowcase from './showcases/SortFilterShowcase'
import StepperShowcase from './showcases/StepperShowcase'
import TabsShowcase from './showcases/TabsShowcase'
import ToastShowcase from './showcases/ToastShowcase'
import ToggleSwitchShowcase from './showcases/ToggleSwitchShowcase'
import TooltipShowcase from './showcases/TooltipShowcase'
import WorkScheduleShowcase from './showcases/WorkScheduleShowcase'
import WorkingDaysShowcase from './showcases/WorkingDaysShowcase'
import { UI_COMPONENT_REGISTRY, UI_FOUNDATION_REGISTRY } from './uiRegistry'
import '@enamelai/design-system/styles.css'
import './UiDesignSystem.page.css'
import './components/UiComponentSidebar.css'
import './components/UiPreviewCanvas.css'
import './components/UiPropertiesPanel.css'
import './showcases/ActionButtonsShowcase.css'
import './showcases/CalendarShowcase.css'
import './showcases/ChartingTabsShowcase.css'
import './showcases/CheckboxShowcase.css'
import './showcases/ColorSelectShowcase.css'
import './showcases/ComboboxShowcase.css'
import './showcases/EmptyStateShowcase.css'
import './showcases/FileActionsShowcase.css'
import './showcases/InputWithUnitShowcase.css'
import './showcases/LinkButtonShowcase.css'
import './showcases/LineChartShowcase.css'
import './showcases/RadioShowcase.css'
import './showcases/ColorPaletteShowcase.css'
import './showcases/TypographyShowcase.css'
import './showcases/IconsShowcase.css'
import './showcases/ContextualMenuShowcase.css'
import './showcases/ButtonShowcase.css'
import './showcases/BreadcrumbsShowcase.css'
import './showcases/BadgeShowcase.css'
import './showcases/BarChartShowcase.css'
import './showcases/DonutChartShowcase.css'
import './showcases/AvatarShowcase.css'
import './showcases/AudioPlayerShowcase.css'
import './showcases/AccordionShowcase.css'
import './showcases/AutocompleteShowcase.css'
import './showcases/AlertShowcase.css'
import './showcases/AreaChartShowcase.css'
import './showcases/DataTableShowcase.css'
import './showcases/DayTimeSelectorShowcase.css'
import './showcases/DescriptionListShowcase.css'
import './showcases/DetailCardShowcase.css'
import './showcases/DrawerShowcase.css'
import './showcases/HeaderShowcase.css'
import './showcases/InputFieldShowcase.css'
import './showcases/ModalShowcase.css'
import './showcases/MetricCardShowcase.css'
import './showcases/MailboxNavShowcase.css'
import './showcases/MultiselectComboboxShowcase.css'
import './showcases/NavListShowcase.css'
import './showcases/OverlayShowcase.css'
import './showcases/PaginationShowcase.css'
import './showcases/PieChartShowcase.css'
import './showcases/ProgressBarShowcase.css'
import './showcases/RichTextEditorShowcase.css'
import './showcases/SearchShowcase.css'
import './showcases/ScreenLoaderShowcase.css'
import './showcases/ScheduleCardShowcase.css'
import './showcases/SchedulerShowcase.css'
import './showcases/SectionCardShowcase.css'
import './showcases/SelectableCardShowcase.css'
import './showcases/SelectableListShowcase.css'
import './showcases/SelectShowcase.css'
import './showcases/SelectChipShowcase.css'
import './showcases/SelectionBoxShowcase.css'
import './showcases/SmoothAreaChartShowcase.css'
import './showcases/SortFilterShowcase.css'
import './showcases/StepperShowcase.css'
import './showcases/TabsShowcase.css'
import './showcases/ToastShowcase.css'
import './showcases/ToggleSwitchShowcase.css'
import './showcases/TooltipShowcase.css'
import './showcases/WorkScheduleShowcase.css'
import './showcases/WorkingDaysShowcase.css'

const scrollPreviewToTop = (): void => {
  requestAnimationFrame(() => {
    document
      .querySelector('.ui-page__workspace .ui-preview__canvas')
      ?.scrollTo({ top: 0, behavior: 'auto' })
  })
}

const UiDesignSystem: React.FC = () => {
  const [selectedComponentId, setSelectedComponentId] = useState('accordion')
  const [dataTableShowcaseKey, setDataTableShowcaseKey] = useState(0)

  const handleSelectComponent = (id: string): void => {
    if (id === 'data-table') {
      setDataTableShowcaseKey((key) => key + 1)
    }

    setSelectedComponentId(id)
    scrollPreviewToTop()
  }

  const selectedComponent = useMemo(
    () =>
      UI_FOUNDATION_REGISTRY.find((item) => item.id === selectedComponentId) ??
      UI_COMPONENT_REGISTRY.find((item) => item.id === selectedComponentId) ??
      UI_COMPONENT_REGISTRY[0],
    [selectedComponentId],
  )

  const renderShowcase = (): React.ReactNode => {
    switch (selectedComponentId) {
      case 'color-palette':
        return <ColorPaletteShowcase />
      case 'typography':
        return <TypographyShowcase />
      case 'icons':
        return <IconsShowcase />
      case 'action-buttons':
        return <ActionButtonsShowcase />
      case 'alert':
        return <AlertShowcase />
      case 'area-chart':
        return <AreaChartShowcase />
      case 'autocomplete':
        return <AutocompleteShowcase />
      case 'button':
        return <ButtonShowcase />
      case 'calendar':
        return <CalendarShowcase />
      case 'checkbox':
        return <CheckboxShowcase />
      case 'color-select':
        return <ColorSelectShowcase />
      case 'combobox':
        return <ComboboxShowcase />
      case 'empty-state':
        return <EmptyStateShowcase />
      case 'file-actions':
        return <FileActionsShowcase />
      case 'input-with-unit':
        return <InputWithUnitShowcase />
      case 'link-button':
        return <LinkButtonShowcase />
      case 'line-chart':
        return <LineChartShowcase />
      case 'radio':
        return <RadioShowcase />
      case 'selection-box':
        return <SelectionBoxShowcase />
      case 'contextual-menu':
        return <ContextualMenuShowcase />
      case 'data-table':
        return <DataTableShowcase key={dataTableShowcaseKey} />
      case 'day-time-selector':
        return <DayTimeSelectorShowcase />
      case 'description-list':
        return <DescriptionListShowcase />
      case 'detail-card':
        return <DetailCardShowcase />
      case 'drawer':
        return <DrawerShowcase />
      case 'header':
        return <HeaderShowcase />
      case 'input-field':
        return <InputFieldShowcase />
      case 'modal':
        return <ModalShowcase />
      case 'metric-card':
        return <MetricCardShowcase />
      case 'mailbox-nav':
        return <MailboxNavShowcase />
      case 'multiselect-combobox':
        return <MultiselectComboboxShowcase />
      case 'nav-list':
        return <NavListShowcase />
      case 'overlay':
        return <OverlayShowcase />
      case 'pagination':
        return <PaginationShowcase />
      case 'progress-bar':
        return <ProgressBarShowcase />
      case 'rich-text-editor':
        return <RichTextEditorShowcase />
      case 'search':
        return <SearchShowcase />
      case 'screen-loader':
        return <ScreenLoaderShowcase />
      case 'schedule-card':
        return <ScheduleCardShowcase />
      case 'scheduler':
        return <SchedulerShowcase />
      case 'section-card':
        return <SectionCardShowcase />
      case 'selectable-card':
        return <SelectableCardShowcase />
      case 'selectable-list':
        return <SelectableListShowcase />
      case 'select':
        return <SelectShowcase />
      case 'select-chip':
        return <SelectChipShowcase />
      case 'sort-filter':
        return <SortFilterShowcase />
      case 'stepper':
        return <StepperShowcase />
      case 'tabs':
        return <TabsShowcase />
      case 'charting-tabs':
        return <ChartingTabsShowcase />
      case 'toggle-switch':
        return <ToggleSwitchShowcase />
      case 'tooltip':
        return <TooltipShowcase />
      case 'toast':
        return <ToastShowcase />
      case 'accordion':
        return <AccordionShowcase />
      case 'breadcrumbs':
        return <BreadcrumbsShowcase />
      case 'avatar':
        return <AvatarShowcase />
      case 'audio-player':
        return <AudioPlayerShowcase />
      case 'badge':
        return <BadgeShowcase />
      case 'bar-chart':
        return <BarChartShowcase />
      case 'donut-chart':
        return <DonutChartShowcase />
      case 'pie-chart':
        return <PieChartShowcase />
      case 'smooth-area-chart':
        return <SmoothAreaChartShowcase />
      case 'work-schedule':
        return <WorkScheduleShowcase />
      case 'working-days':
        return <WorkingDaysShowcase />
      default:
        return null
    }
  }

  return (
    <div className="ui-page">
      <UiComponentSidebar
        selectedId={selectedComponentId}
        onSelect={handleSelectComponent}
      />

      <div className="ui-page__workspace">
        {renderShowcase() ?? (
          <div className="ui-page__empty">
            <h2>{selectedComponent.label}</h2>
            <p>{selectedComponent.description}</p>
            <p className="ui-page__empty-note">Showcase coming soon.</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default UiDesignSystem
